import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
import { getApiBaseUrl } from '../utils/Config';

/**
 * Handles Supabase auth redirects:
 *  - Email confirmation (type=signup) → check DoesCandidateExist → navigate
 *  - Password recovery (type=recovery) → redirect to /auth/reset-password
 *  - Direct navigation while logged in → check DoesCandidateExist → navigate
 */
const AuthCallback = () => {
    const navigate = useNavigate();
    const baseUrl = getApiBaseUrl();
    const [error, setError] = useState(null);

    useEffect(() => {
        const handleCallback = async () => {
            try {
                // Supabase SDK automatically parses the URL hash and establishes session
                const { data: { session }, error: sessionError } = await supabase.auth.getSession();

                if (sessionError) throw sessionError;

                // PASSWORD_RECOVERY type — redirect to reset password page
                // Supabase puts the recovery token in the URL hash; getSession() handles it
                const hash = window.location.hash;
                if (hash.includes('type=recovery')) {
                    navigate('/auth/reset-password');
                    return;
                }

                if (!session) {
                    navigate('/login');
                    return;
                }

                const res = await fetch(
                    `${baseUrl}/api/Authentication/DoesCandidateExist?b2cObjectId=${session.user.id}`,
                    { headers: { Authorization: `Bearer ${session.access_token}` } }
                );

                if (!res.ok) throw new Error(`API error ${res.status}`);

                const data = await res.json();
                const returnTo = sessionStorage.getItem('postLoginRedirect') || '/candidate/profile';
                sessionStorage.removeItem('postLoginRedirect');

                navigate(data.success && data.result ? returnTo : '/candidate/additional-info');
            } catch (err) {
                console.error('Auth callback error:', err);
                setError('Sign in could not be completed. Please try again.');
            }
        };

        handleCallback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="loadingStyle">
            {error ? <p>{error}</p> : <p>Loading...</p>}
        </div>
    );
};

export default AuthCallback;
